import { defineComponent, onMounted, ref, watch } from 'vue'
import { useExpose, useNamespace } from '@xzx-design/hooks'
import Swipe from '@xzx-design/components/swipe'

import { tabsContentProps } from './types/tabs-content'

import type { SwipeInstance } from '@xzx-design/components/swipe'

export default defineComponent({
  props: tabsContentProps,
  setup(props, { slots, emit }) {
    const { e } = useNamespace('tabs')

    const swipeRef = ref<SwipeInstance>()

    const onChange = (index: number) => emit('change', index)

    const renderChildren = () => {
      const Content = slots.default?.()

      if (props.animated || props.swipeable) {
        return (
          <Swipe
            ref={swipeRef}
            loop={false}
            class={e('track')}
            duration={+props.duration * 1000}
            touchable={props.swipeable}
            lazyRender={props.lazyRender}
            showIndicators={false}
            onChange={onChange}
          >
            {Content}
          </Swipe>
        )
      }

      return Content
    }

    const swipeToCurrentTab = (index: number) => {
      const swipe = swipeRef.value
      if (swipe && swipe.state.active !== index) {
        swipe.swipeTo(index, { immediate: !props.inited })
      }
    }

    watch(() => props.currentIndex, swipeToCurrentTab)

    onMounted(() => {
      swipeToCurrentTab(props.currentIndex)
    })

    useExpose({ swipeRef })

    return () => <div class={[e('content')]}>{renderChildren()}</div>
  },
})
